<template>
  <div class="pull-right">
    <a v-if="invitations > 0" v-show="show" @click="startInvitation()" data-remote="true" rel="nofollow" data-method="post"  v-bind:href="endPoint" class="btn btn-lg btn-primary">
      馬上邀請 {{invitations}} 位求職者
    </a>
    <a v-else disabled="disabled" href="#" class="btn btn-lg btn-primary">你目前沒有可邀請的求職者</a>
  </div>
</template>

<script>
export default {
  props: ["invitations", "endPoint"],
  data() {
    return {
      show: true
    };
  },
  created() {

  },
  computed: {

  },
  methods: {
    startInvitation() {
      this.show = false
      eventHub.$emit('job-invitation-start');
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/job_invitation_submit.vue